module.exports = __webpack_public_path__ + "static/QuoteActivityAndTasks-8f54704082be4ad0982491e3bfc6b930.png";